import { useReadContract } from 'wagmi';
import { useEffect, useState } from 'react';

export const useReadContractHelper = () => {
    const [readContractDetails, setReadContractDetails] = useState({
        address: '',
        chainId: null,
        abi: null,
        functionName: null,
        arg: [],
    });

    const { data, error, isLoading, refetch } = useReadContract({
        abi: readContractDetails.abi,
        address: readContractDetails.address,
        functionName: readContractDetails.functionName,
        chainId: readContractDetails.chainId,
        args: readContractDetails.arg,
        query: {
            enabled:
                !!readContractDetails.address &&
                !!readContractDetails.chainId &&
                !!readContractDetails.abi &&
                !!readContractDetails.functionName,
        },
    });

    const interact = (abi, contractAddress, functionName, arg, chainId) => {
        setReadContractDetails({
            abi,
            address: contractAddress,
            functionName,
            arg,
            chainId,
        });
    }


    return { data, error, isLoading, interact, refetch };
};
